var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3463 14.1576C11.9313 15.3853 10.0845 16.1282 8.06412 16.1282C3.61043 16.1282 0 12.5178 0 8.06412C0 3.61043 3.61043 0 8.06412 0C12.5178 0 16.1282 3.61043 16.1282 8.06412C16.1282 10.0839 15.3857 11.9303 14.1587 13.3451L17.8329 17.0193C18.0572 17.2437 18.0572 17.6074 17.8329 17.8317C17.6085 18.0561 17.2448 18.0561 17.0204 17.8317L13.3463 14.1576ZM1.14894 8.06412C1.14894 4.24497 4.24497 1.14894 8.06412 1.14894C11.8833 1.14894 14.9793 4.24497 14.9793 8.06412C14.9793 9.93781 14.2341 11.6375 13.0239 12.8828C12.9972 12.9016 12.9718 12.923 12.9479 12.9468C12.924 12.9707 12.9027 12.9962 12.8839 13.0229C11.6384 14.2337 9.93834 14.9793 8.06412 14.9793C4.24497 14.9793 1.14894 11.8833 1.14894 8.06412Z",
    fill: "#005FEA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Search.4a8d9cf7e595458a7efc3dfb528eb3ad.svg";